var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-modal-dialog',{staticClass:"dialog",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var title = ref.title;
var message = ref.message;
var isHtml = ref.isHtml;
return [_c('md-dialog-title',[_vm._v(_vm._s(title))]),_vm._v(" "),(isHtml)?_c('md-dialog-content',{domProps:{"innerHTML":_vm._s(message)}}):_c('md-dialog-content',[_vm._v(_vm._s(message))]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary md-flat",on:{"click":_vm.onClose}},[_vm._v("Close")])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }